import AirModalCarousel from "./AirModalCarousel"

export default  AirModalCarousel;



// WEBPACK FOOTER //
// ./src/common/components/AirModalCarousel/index.js